import { ColumnDefinition } from 'components/Grid/types';

// The related endpoints have no filter backend and order server-side, so a control here does nothing.
export const withoutControls = (columns: ColumnDefinition[]): ColumnDefinition[] =>
  columns.map((column) => ({ ...column, filterable: false, sortable: false }));
